const resource = 'invoices'

export default $axios => ({
  download(id) {
    return $axios({
      method: 'GET',
      url: `/${resource}/${id}/download`,
      responseType: 'blob',
    })
  },

  getServiceName: name => 'invoiceService',
})
